import TitledToggleSwitch from './TitledToggleSwitch';
export default TitledToggleSwitch;